import SideBar from '../../components/SideBar';
import { Outlet } from 'react-router-dom';

const Course = () => {
  return (
    <>
      <div className='d-flex flex-grow-1 h-100' data-testid='course'>
        <SideBar />
        <div className='flex-grow-1 h-100'>
          {/* Outlet will contain content of desired the page */}
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Course;
